
import Vue from "vue";
import {Component, Watch, Emit} from "vue-property-decorator";
import {translate} from "../../services/translation/translation";
import {dataService} from "../../services/data/category-data-service";
import ProjectComponent from "../project/project.vue";
import PaginatorComponent from "../paginator/paginator.vue";
import "./category-page.less";
import SimpleDropdownComponent from "../simple-dropdown/simple-dropdown.vue";
import loader from "../loader/loader.vue";

@Component({
  components: {
    ProjectComponent,
    PaginatorComponent,
    SimpleDropdownComponent,
    loader,
  }
})
export default class categoryPage extends Vue {

  private buildingStates = dataService.categoryData.buildingStates;
  private categories = dataService.categoryData.categories;
  private countries = dataService.categoryData.countries;
  private projects = dataService.categoryData.projects;

  private category = dataService.categoryData.category;
  private country = dataService.categoryData.country;
  private buildingState = dataService.categoryData.buildingState;


  private subscription;

  private showLoader: boolean = false;

  private updatedFromUrl: boolean = false;
  private disableUpdateQueryParams: boolean = false;

  private blockCountryUpdate: boolean = false;
  private blockCategoryUpdate: boolean = false;

  @Watch("buildingState")
  private buildingStateChanged(value) {
    dataService.categoryData.buildingState = value;
    dataService.clearProjects();
    this.paginator.current_page = 1;
    dataService.categoryData.paginator = this.paginator;
    dataService.updateProjects();
    this.updatequeryParams();

  }

  @Watch("category")
  private categoryChanged(value) {
    dataService.categoryData.category = value;
    dataService.clearProjects();
    this.paginator.current_page = 1;
    dataService.categoryData.paginator = this.paginator;
    if (this.blockCategoryUpdate === false) {
      dataService.updateProjects();
    } else {
      this.blockCategoryUpdate = false;
    }
    this.updatequeryParams();
    this.updatequeryParams();
  }

  @Watch("country")
  private countryChanged(value) {
    dataService.categoryData.country = value;
    dataService.clearProjects();
    this.paginator.current_page = 1;
    dataService.categoryData.paginator = this.paginator;
    if (this.blockCountryUpdate === false) {
      dataService.updateProjects();
    } else {
      this.blockCountryUpdate = false;
    }
    this.updatequeryParams();
  }

  private paginatorType = 'more';//paginator


  private paginator: any = {
    current_page: 1,
    last_page: 1,
    total: 0
  };

  isEnabledBuildingStateFilter() {
    //@ts-ignore
    return window.currentDomain && window.currentDomain.id == 12
  }

  async mounted() {
    dataService.categoryData.paginatorType = this.paginatorType;
    this.subscription = dataService.categoryData.data.subscribe(
        (ev) => {
          //console.log(ev);
          if (ev.event == 'update-projects') {
            this.projects = ev.data;
            this.paginator = ev.paginator;
          }
          if (this.updatedFromUrl === false) {
            this.updatedFromUrl = true;
            this.updateFromUrl();
          }
        }
    );
    await this.$nextTick();

  }

  beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  pageSelected(pageNum, callback = function () {
  }) {
    let self = this;
    this.paginator.current_page = pageNum;
    dataService.categoryData.paginator = this.paginator;
    dataService.updateProjects(
        function () {
          self.showLoader = false;
          callback();
        }
    );
    this.updatequeryParams();
  }

  updatequeryParams(useScrolltop = false) {
    if (this.disableUpdateQueryParams) {
      return true;
    }
    let paramsObject: any = {};
    if (this.category) {
      paramsObject.category = this.category.id;
    }
    if (this.country) {
      paramsObject.country = this.country.id;
    }
    paramsObject.page = this.paginator.current_page;
    if (useScrolltop) {
      paramsObject.scrt = window.scrollY
    }
    let params = new URLSearchParams(paramsObject);
    history.pushState('', '', '?' + params.toString())
  }

  updateFromUrl() {
    let data = {
      category: this.getQueryParam('category'),
      country: this.getQueryParam('country'),
      page: this.getQueryParam('page'),
      scrollTop: this.getQueryParam('scrt'),
    };
    //letiltjuk a queryparams átírást
    this.disableUpdateQueryParams = true;
    //letiltjuk a project list updatet, hogy ne 3szor csak 1szer frissítse majd be a listát
    let currentCategory: any = null;
    let currentCountry: any = null;
    if (data.category !== null) {
      let categories = this.categories.filter(function (elem) {
        return elem.id == data.category;
      });
      if (categories.length > 0) {
        currentCategory = categories[0];
        dataService.categoryData.category = currentCategory;
      }
    }
    if (data.country !== null) {
      let countries = this.countries.filter(function (elem) {
        return elem.id == data.country;
      });
      if (countries.length > 0) {
        currentCountry = countries[0];
        dataService.categoryData.country = currentCountry;
      }
    }
    if (currentCountry != null) {
      this.blockCountryUpdate = true;
      this.country = currentCountry;
    }
    if (currentCategory != null) {
      this.blockCategoryUpdate = true;
      this.category = currentCategory;
    }

    dataService.clearProjects();
    this.pageSelected(1, () => {
      this.blockCountryUpdate = false;
      this.blockCategoryUpdate = false;
      this.loadPages(data.page, data.scrollTop);
    });

    this.disableUpdateQueryParams = false;
  }

  loadPages(pageNum, scrollTop: any) {
    let self = this;
    if (pageNum > self.paginator.current_page) {
      self.pageSelected(self.paginator.current_page + 1, function () {
        self.loadPages(pageNum, scrollTop);
      })
    } else {
      if (scrollTop != null) {
        setTimeout(function () {
          window.scroll(0, parseInt(scrollTop));
        }, 200);
      }
    }
  }

  getQueryParam(name: string) {
    let queryString = window.location.search;
    let params = new URLSearchParams(queryString);
    return params.get(name);
  }

  navigated(url) {
    this.updatequeryParams(true);
    //location.href=url;
  }


  trans(key) {
    return translate(key);
  }

  showMore() {
    this.showLoader = true;
    this.pageSelected(this.paginator.current_page + 1);

  }
}
